export const Card = {
    MuiCard: {
        defaultProps: {
            elevation: 0
        },
        styleOverrides: {
            root: ()=>({
                    /**
                 * By default, increasing the elevation overlays a slight tint to indicate that the
                 * component is elevated. If you don't want this behavior, you can disable it by
                 * setting the backgroundImage for Paper to none.
                 */ "&.MuiPaper-root": {
                        backgroundImage: "none"
                    }
                })
        }
    },
    MuiCardContent: {
        styleOverrides: {
            root: ({ theme })=>({
                    ":last-child": {
                        paddingBottom: theme.spacing(2)
                    }
                })
        }
    }
};

//# sourceMappingURL=Card.js.map